import {
  DeleteOutlined,
  EditOutlined,
  ExportOutlined,
  LeftOutlined,
  SaveOutlined,
  SendOutlined,
  PicLeftOutlined,
  CloseSquareOutlined
} from "@ant-design/icons";
import { Button, Flex } from "antd";

const FormActionButton = ({
  goBack,
  save,
  loadingButton,
  saveAndClose,
  loadingButtonClose,
  handleDelete,
  loadingButtonDelete,
  handleRedirectEdit,
  loadingButtonEdit,
  guiDuyetXuatBan,
  loadingGuiDuyet,
  xuatBan,
  loadingXuatBan,
  huyXuatBan,
  loadingHuyXuatBan,
  trangThai,
  isDuyetXuatBan,
  idtulieu
}: any) => {
  return (
    <Flex justify="center" align="center">
      {goBack && (
        <Button className="btn-save" onClick={goBack}>
          <div className="content-btn">
            <span className="icon-back" />
            <span className="name">
              <LeftOutlined /> Quay về
            </span>
          </div>
        </Button>
      )}
      {save && (
        <Button
          onClick={save}
          loading={loadingButton}
          className="btn-save"
          type="primary"
          htmlType="submit"
        >
          <SaveOutlined />
          Lưu
        </Button>
      )}
      {saveAndClose && (
        <Button
          onClick={saveAndClose}
          loading={loadingButtonClose}
          className="btn-save"
          type="primary"
          htmlType="submit"
        >
          <ExportOutlined />
          Lưu và đóng
        </Button>
      )}
      {handleRedirectEdit && (
        <Button
          loading={loadingButtonEdit}
          onClick={handleRedirectEdit}
          style={{ background: "green", color: "#fff" }}
          htmlType="submit"
        >
          <EditOutlined />
          Chỉnh sửa
        </Button>
      )}
      {handleDelete && (
        <Button
          loading={loadingButtonDelete}
          onClick={handleDelete}
          type="dashed"
          htmlType="submit"
        >
          <DeleteOutlined />
          Xóa
        </Button>
      )}
      {guiDuyetXuatBan && idtulieu && (trangThai === 1 || trangThai === 4) && (
        <Button
          className="btn-save"
          loading={loadingGuiDuyet}
          onClick={guiDuyetXuatBan}
          type="primary"
          htmlType="submit"
        >
          <SendOutlined />
          Gửi duyệt xuất bản
        </Button>
      )}
      {xuatBan && idtulieu && isDuyetXuatBan && (trangThai === 1 || trangThai === 2 || trangThai === 4) && (
        <Button
          className="btn-save"
          loading={loadingXuatBan}
          onClick={xuatBan}
          type="primary"
          htmlType="submit"
        >
          <PicLeftOutlined />
          Xuất bản
        </Button>
      )}
      {huyXuatBan && idtulieu && isDuyetXuatBan && (trangThai === 2 || trangThai === 3) && (
        <Button
          className="btn-save"
          loading={loadingHuyXuatBan}
          onClick={huyXuatBan}
          color="danger"
          variant="solid"
          htmlType="submit"
        >
          <CloseSquareOutlined />
          Hủy xuất bản
        </Button>
      )}
    </Flex>
  );
};

export default FormActionButton;
